export const css = {
	root: '_2e_96DgS',
	toolbar: 'HNf-lTbw',
	alphabutton: '_3hyh67z8',
	numberbutton: '_2Rr5JKgc',
	searchinput: 'POXbwaiN',
	selectedbutton: '_37CDXwTz',
	invalidbutton: '_3mkjM_bv',
	result: '_3bNZCw9x',
	terms: '_3YGZQLI8',
	term: 'lHDnrEvt',
	definition: '_2eUBTf7F',
	' _key': 'glossary/glossary'
};

export default css;
